<template>
  <div class="h5-container">
    <!-- 登录主体区域 -->
    <div class="login-wrapper">
      <!-- logo + 标题容器：新增小logo区域 -->
      <div class="title-logo-container">
        <!-- 原有大logo -->
        <img
            src="@/assets/img/h5/login_new.png"
            alt="球杆售后系统logo"
            class="system-logo"
        >
        <!-- 新增：三个小logo一行排列容器 -->
        <div class="small-logos-wrap">
          <img src="@/assets/img/h5/U.png" alt="U小logo" class="small-logo">
          <img src="@/assets/img/h5/poison.png" alt="poison小logo" class="small-logo">
          <img src="@/assets/img/h5/guifu.png" alt="guifu小logo" class="small-logo">
        </div>
        <!-- 原有系统标题 -->
        <div class="system-title">球杆售后系统</div>
      </div>

      <!-- 登录方式切换标签 -->
      <van-tabs v-model="activeTab" class="login-tabs" animated swipeable>
        <van-tab title="密码登录" name="password"></van-tab>
        <van-tab title="验证码登录" name="code"></van-tab>
      </van-tabs>

      <!-- 登录表单 -->
      <van-form @submit="onSubmit" class="login-form" ref="loginFormRef">
        <!-- 手机号输入框（公共）：补充校验提示文案 -->
        <van-field
            v-model="formData.phoneNumber"
            name="phoneNumber"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            clearable
            @blur="onPhoneBlur"
        />
        <div class="error-tip" v-if="errorMsg.phoneNumber">{{errorMsg.phoneNumber}}</div>

        <!-- 验证码输入框 + 获取验证码按钮（验证码登录专属） -->
        <van-field
            v-if="activeTab === 'code'"
            v-model="formData.code"
            name="code"
            label="验证码"
            placeholder="请输入6位验证码"
            clearable
            @blur="onCodeBlur"
        >
<!--          :rules="[{ required: true, message: '请输入验证码'}, { len: 6, message: '验证码为6位数字' }]"-->
          <template #button>
            <van-button
                size="small"
                type="primary"
                :disabled="countDown > 0 || !isMobileValid"
                @click="getVerifyCode"
                class="code-btn"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </van-button>
          </template>
        </van-field>
        <div class="error-tip" v-if="errorMsg.code && activeTab === 'code'">{{errorMsg.code}}</div>

        <!-- 密码输入框（密码登录专属，带显隐密码） -->
        <van-field
            v-if="activeTab === 'password'"
            v-model="formData.password"
            name="password"
            label="密码"
            placeholder="请输入6-16位密码"
            type="password"
            clearable
            show-password
            @blur="onPassWordBlur"
        />
<!--        :rules="[{ required: true, message: '请输入密码'}, { min: 6, max: 16, message: '密码为6-16位字符' }]"-->
        <div class="error-tip" v-if="errorMsg.password && activeTab === 'password'">{{errorMsg.password}}</div>

        <!-- 登录按钮容器 -->
        <div class="login-btn-wrap">
          <van-button
              type="info"
              round
              block
              native-type="submit"
              class="login-btn"
              :loading="isLoading"
          >
            登录
          </van-button>

          <!-- 新增：链接分栏容器 → 实现左/右对齐 -->
          <div class="link-group">
            <!-- 忘记密码：左对齐，仅密码登录显示 -->
            <router-link
                v-if="activeTab === 'password'"
                to="/forgot_password"
                class="activate-link"
            >
              忘记密码
            </router-link>
            <!-- 用户注册：右对齐，始终显示 -->
            <router-link to="/activate_cue" class="activate-link activate-link-right">
              用户注册
            </router-link>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
// 脚本部分完全不变
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import {memberLogin, sendCode} from "@/api/sales";
import {mapActions} from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      activeTab: 'password',
      formData: {
        phoneNumber: "",
        code: "",
        password: ""
      },
      errorMsg: {
        phoneNumber: "",
        code: "",
        password: ""
      },
      countDown: 0,
      isLoading: false,
      mobileReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/,
      timer: null,
      loginFormRef: null
    };
  },
  computed: {
    isMobileValid() {
      return this.mobileReg.test(this.formData.phoneNumber);
    }
  },
  watch: {
    activeTab(newVal) {
      if (this.loginFormRef) {
        this.loginFormRef.resetValidation();
      }
      if (newVal === 'password') {
        this.formData.code = '';
      } else {
        this.formData.password = '';
      }
    }
  },
  methods: {
    onPhoneBlur() {
      this.errorMsg.phoneNumber = '';

      if (!this.formData.phoneNumber) {
        this.errorMsg.phoneNumber = '请输入手机号';
        return;
      }
      const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/;
      const flag = reg.test(this.formData.phoneNumber);
      if (!flag) {
        this.errorMsg.phoneNumber = '请输入合法的手机号';
      }
    },
    onPassWordBlur() {
      this.errorMsg.password = '';
      if (!this.formData.password) {
        this.errorMsg.password = '请输入密码';
        return;
      }

      const password = this.formData.password.trim(); // 去除首尾空格（可选，根据业务需求决定）
      const minLength = 6;
      const maxLength = 16;

      if (password.length < minLength || password.length > maxLength) {
        this.errorMsg.password = `密码长度需为${minLength}-${maxLength}位字符`;
      }
    },
    onCodeBlur() {
      this.errorMsg.code = '';
      if (!this.formData.code) {
        this.errorMsg.code = '请输入验证码';
        return;
      }

      const password = this.formData.code.trim(); // 去除首尾空格（可选，根据业务需求决定）
      const minLength = 6;

      if (password.length < minLength || password.length > minLength) {
        this.errorMsg.code = '验证码为6位数字';
      }
    },
    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },
    ...mapActions(['setToken']),

    async getVerifyCode() {
      if (!this.isMobileValid) {
        Toast("请输入正确的手机号（港澳台需带对应区号）");
        return;
      }
      try {
        const res = await sendCode(this.formData.phoneNumber, 'login')
        if (res.code === 200) {
          Toast("验证码已发送，请注意查收");
          this.countDown = 60
          this.timer = setInterval(() => {
            this.countDown--
            if (this.countDown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.showDialogMsg(res.returnMsg || '获取验证码失败');
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      }
    },

    async onSubmit() {

      this.onPhoneBlur();
      if(this.activeTab === 'password') {
        this.onPassWordBlur();
      }else{
        this.onCodeBlur();
      }
      console.log(this.errorMsg);
      if(this.errorMsg.phoneNumber || this.errorMsg.password || this.errorMsg.code) {
        return;
      }
      this.isLoading = true
      try {
        const loginParams = {
          phoneNumber: this.formData.phoneNumber,
          ...(this.activeTab === 'code'
                  ? {captcha: this.formData.code}
                  : {password: this.formData.password}
          )
        }
        const res = await memberLogin(loginParams);
        if (res.code === 200) {
          this.setToken(res.token)
          Toast.success('登录成功');
          this.$router.replace('/app_home')
        } else {
          Toast(res.returnMsg || '登录失败');
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      } finally {
        this.isLoading = false
      }
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
// 全局容器
.h5-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;

  > * {
    position: relative;
    z-index: 1;
  }
  // PC端容器宽度50%居中（适配全局样式）
  @media (min-width: 768px) {
    width: 50%;
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 30px;
  }
}

// 登录主体包裹层
.login-wrapper {
  width: 100%;
  max-width: 400px;
  // PC端适配最大宽度
  @media (min-width: 768px) {
    max-width: 100%;
  }
}

// logo + 标题容器
.title-logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    margin-bottom: 8px; // 减小与页签的间距
  }
}

// 原有大logo样式
.system-logo {
  width: 100%;
  object-fit: contain;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
}

// 小logo容器
.small-logos-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 16px;
  background: #FFFFFF;
  padding: 0 10px;
  box-sizing: border-box;
  // PC端小logo间距适配
  @media (min-width: 768px) {
    gap: 16px;
    margin-bottom: 16px; // 减小小logo与标题/页签的间距
  }
}

// 小logo样式
.small-logo {
  height: 40px;
  @media (min-width: 768px) {
    height: 90px;
  }
  width: auto;
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
  display: block;
  max-width: 100%;
  padding: 0;
}

// 系统标题
.system-title {
  font-size: 24px;
  @media (min-width: 768px) {
    font-size: 30px;
    margin-bottom: 8px; // 减小标题与页签的间距
  }
  font-weight: bold;
  color: #D4AF37;
  text-align: center;
  letter-spacing: 2px;
  margin-bottom: 0;
}

// 登录方式切换标签样式 - 核心调整
.login-tabs {
  margin-bottom: 12px;
  @media (min-width: 768px) {
    margin-top: 0;
    margin-bottom: 8px; // 减小页签与表单的间距（关键）
  }

  ::v-deep {
    .van-tabs__wrap {
      background: transparent;
      @media (min-width: 768px) {
        height: 40px; // 页签容器高度从70px→40px（核心缩小）
        line-height: 40px; // 文字垂直居中
      }
    }

    .van-tab {
      color: #999;
      font-size: 16px;
      @media (min-width: 768px) {
        font-size: 18px; // 页签文字从25px→18px（缩小）
        height: 40px; // 匹配容器高度
        line-height: 40px; // 文字垂直居中
      }
    }

    .van-tabs__nav {
      background: none;
    }

    .van-tab--active {
      color: #D4AF37;
      font-weight: 500;
    }

    .van-tabs__line {
      background-color: #D4AF37;
      width: 30px;
      @media (min-width: 768px) {
        bottom: 4px; // 下划线从80px→4px（回归正常位置）
        height: 3px;
        width: 40px; // 下划线宽度从70px→40px（匹配文字）
      }
    }

    // 移除原有错误的高度设置，改用上面的适配
    .van-tabs--line .van-tabs__wrap {
      @media (min-width: 768px) {
        height: 40px; // 覆盖原有70px，缩小页签高度
      }
    }
  }
}

// 登录表单
.login-form {
  background: rgba(26, 26, 26, 0.7);
  padding: 24px;
  border-radius: 12px;
  box-sizing: border-box;
  width: 100%;
  // PC端表单内边距适配
  @media (min-width: 768px) {
    padding: 30px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    margin-top: 0; // 确保表单与页签间距紧凑
  }
}

// 验证码按钮
.code-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  // PC端验证码按钮文字适配
  @media (min-width: 768px) {
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }
}

// 登录按钮容器
.login-btn-wrap {
  margin-top: 32px;
  @media (min-width: 768px) {
    margin-top: 0;
  }
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 链接分栏容器
.link-group {
  display: flex;
  align-items: center;
  width: 100%;
}

// 基础链接样式
.activate-link {
  color: #D4AF37;
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 15px; // PC端链接文字适配
  }
  text-decoration: none;
  max-width: 100%;

  &:hover {
    color: #B8860B;
    text-decoration: underline;
  }
}

.activate-link-right {
  margin-left: auto;
}

// 登录按钮
.login-btn {
  height: 48px;
  font-size: 16px;
  @media (min-width: 768px) {
    height: 42px; // PC端按钮高度缩小
    font-size: 15px; // PC端按钮文字适配
  }
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: bold;
  width: 100%;
}

// 适配Vant组件样式 - 文本框核心适配
::v-deep .van-field__label {
  width: 50px;
  line-height: 44px;
  font-size: 14px; // 移动端标签文字大小
  display: flex;
  align-items: center;
  justify-content: center;
  // PC端文本框标签适配
  @media (min-width: 768px) {
    width: 60px; // 加宽标签宽度适配文字
    font-size: 15px; // PC端标签文字放大
    line-height: 42px; // 匹配PC端输入框高度
  }
}

::v-deep .van-field {
  --van-field-label-color: #fff;
  --van-field-input-color: #fff;
  --van-field-placeholder-color: #999;
  --van-field-border-color: rgba(212, 175, 55, 0.2);
  --van-field-font-size: 14px; // 移动端输入框文字大小
  margin-bottom: 10px !important;
  border-radius: 10px;
  box-sizing: border-box;
  height: 44px;
  min-height: 44px;
  line-height: 44px;
  @media (min-width: 768px) {
    --van-field-font-size: 15px; // PC端输入框文字核心适配
    height: 42px; // PC端输入框高度缩小
    min-height: 42px;
    line-height: 42px; // 匹配高度，文字垂直居中
    margin-bottom: 10px !important; // 调整间距适配错误提示
    // PC端输入框内边距适配
    padding: 0 10px;
  }
  display: flex;
  align-items: center;
  position: relative !important;
}

::v-deep .van-field__control {
  height: 44px;
  line-height: 44px;
  font-size: 14px; // 移动端输入文字大小
  flex: 1;
  // PC端输入框内容文字适配
  @media (min-width: 768px) {
    font-size: 15px; // PC端输入文字放大
    height: 42px;
    line-height: 42px;
  }
}

// PC端占位符文字适配
::v-deep .van-field__control::placeholder {
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 15px;
    color: #aaa; // 提亮占位符，PC端更易识别
  }
}

::v-deep .van-field__button {
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  flex-shrink: 0;
  @media (min-width: 768px) {
    height: 42px; // 匹配PC端输入框高度
  }
}

::v-deep .van-icon-eye-o,
::v-deep .van-icon-eye,
::v-deep .van-field__clear {
  color: #D4AF37;
  line-height: 44px;
  @media (min-width: 768px) {
    line-height: 42px; // 匹配PC端输入框高度
    font-size: 16px; // PC端图标大小适配
  }
}

// 🔴 核心修复：错误提示文字适配
.login-form ::v-deep .van-field__error-message {
  position: absolute !important;
  bottom: -24px !important;
  left: 0 !important;
  color: #ee0a24 !important;
  font-size: 12px !important;
  @media (min-width: 768px) {
    font-size: 13px !important; // PC端错误提示文字放大
    bottom: -22px !important; // 调整位置适配缩小的输入框
  }
  line-height: 20px !important;
  padding-left: 0 !important;
  margin: 0 !important;
  z-index: 9999 !important;
  width: 100% !important;
  text-align: left !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

// 🔴 错误状态下的输入框边框样式优化
.login-form ::v-deep .van-field--error {
  border-color: #ee0a24 !important;
}

::v-deep .van-button--info {
  --van-button-info-background: #D4AF37;
  --van-button-info-border-color: #D4AF37;
}
.error-tip{
  font-size: 12px;
  color: #ee0a24;
  margin: 0 0 4px 0;
  padding-left: 4px;
  @media (min-width: 768px) {
    font-size: 13px ;
    margin: 0 0 10px 0;
  }
}
</style>